// extracted by mini-css-extract-plugin
export var homepage__fullWidthCarousel = "HomePage-module--homepage__fullWidthCarousel--3c3e2";
export var homepage__ideas = "HomePage-module--homepage__ideas--f60ea";
export var homepage__sectors = "HomePage-module--homepage__sectors--0a0a1";
export var homepage__solutions = "HomePage-module--homepage__solutions--a5d60";
export var homepage__testimonialCarousel = "HomePage-module--homepage__testimonialCarousel--64311";
export var homepage__topHero = "HomePage-module--homepage__topHero--df88d";
export var homepage__videoTextSection = "HomePage-module--homepage__videoTextSection--8e351";